module.exports = "/images/home_section_cover_agent_loan_officer.jpg?604cfc12cc212ad70350348477621f39";